import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import PrebuiltBetBuilderCouponImpl from './pre-built-bet-builder-coupon.js';
import { noop } from 'mojito/utils';

const UIView = MojitoCore.Presentation.UIView;

/**
 * PrebuiltBetBuilderCoupon is a component that renders a coupon with grouped pre build bet builder markets.
 * Will fetch events group using provided pbbbGroupId to display pbbb markets for each event in a group.
 *
 * @class PrebuiltBetBuilderCoupon
 * @memberof Mojito.Modules
 */

/**
 * PrebuiltBetBuilderCoupon propTypes.
 *
 * @property {string} [pbbbGroupId] - The group id parameter used to fetch pbbb events groups.
 * @property {string} [selectedGroupId] - Selected pbbb events group id.
 * @property {Function} [onDataLoad = () => {}] - Callback triggered when all child elements have loaded.
 *
 * @memberof Mojito.Modules.PrebuiltBetBuilderCoupon
 */
const propTypes = {
    pbbbGroupId: PropTypes.string,
    selectedGroupId: PropTypes.string,
    onDataLoad: PropTypes.func,
};

const defaultProps = {
    onDataLoad: noop,
};

export default UIView(
    'PrebuiltBetBuilderCoupon',
    PrebuiltBetBuilderCouponImpl,
    propTypes,
    defaultProps
);
